import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { ROUTER_NAME } from '../../router'
import Exam from '../../models/exam'
import ExamStatusForm from '../../../api/v2/forms/answer_status'
import { examTestState } from '../../stores/exam_test'
import UserExam from '../../models/user_exam'

@Component
export default class ExamMixin extends Vue {
  TYPE_USE_NIGATE_EXAM = Exam.TYPE_USE_NIGATE_EXAM
  TYPE_USE_SPECIAL_EXAM = Exam.TYPE_USE_SPECIAL_EXAM
  TYPE_USE_EXAM_FROM_FAILED = Exam.TYPE_USE_EXAM_FROM_FAILED

  confimDialog = false

  async startExam(item: Exam, userExam: UserExam) {
    if (!item.isDone(userExam)) {
      if (!item.isStarted(userExam)) {
        const examStatusForm = new ExamStatusForm()
        examStatusForm.examId = item.id
        examStatusForm.isStartExam = true
        examStatusForm.userExamId = userExam.id
        await examTestState.saveExamStatus({ examStatusForm })
        this.gotoTest(examTestState.exam, userExam)
      }
    }
  }

  async resultExam(item: Exam, userExam: UserExam) {
    if (item.isTestTimeOver(userExam)) {
      const examStatusForm = new ExamStatusForm()
      examStatusForm.examId = item.id
      examStatusForm.isFinishExam = true
      examStatusForm.userExamId = userExam.id
      await examTestState.saveExamStatus({ examStatusForm })

      this.gotoResult(item, userExam)
    }
  }

  async continueExam(item: Exam, userExam: UserExam) {
    if (userExam.questions.length && !item.isDone(userExam)) {
      this.gotoTest(item, userExam)
    }
  }

  async gotoExam(item: Exam, userExam?: UserExam) {
    const run = async ()=>{
      await this.$router.push({
        name: ROUTER_NAME.EXAM_SHOW,
        params: {
          examId: item.id.toString()
        },
        query: userExam ? {
          user_exam_id: `${userExam.id}`
        } : {}
      })
    }

    if (this.$route.name === ROUTER_NAME.EXAM_SHOW) {
      await run()
      window.location.reload();
    } else {
      await run()
    }
  }

  gotoDetail(item: Exam) {
    this.$router.push({
      name: ROUTER_NAME.EXAM_DETAIL,
      params: {
        examId: item.id.toString()
      }
    })
  }

  gotoTest(item: Exam, userExam: UserExam) {
    this.$router.push({
      name: ROUTER_NAME.QUESTION,
      params: {
        examId: `${item.id}`,
        questionId: `${userExam.questions[0].id}`,
      },
      query: {
        user_exam_id: `${userExam.id}`
      }
    })
  }

  async reTest(item: Exam, examType: string = '') {
    const response = await examTestState.reTest(item, examType)
    const run = async ()=>{
      await this.$router.push({
        name: ROUTER_NAME.EXAM_SHOW,
        params: {
          examId: `${response.examId}`
        },
        query: {
          user_exam_id: `${response.userExamId}`
        }
      })
    }

    if (this.$route.name === ROUTER_NAME.EXAM_SHOW) {
      await run()
      window.location.reload();
    } else {
      await run()
    }
  }

  confimClearAllTest(item: Exam){
    this.confimDialog = false
    examTestState.clearAllTest(item).then(()=>{
      this.gotoExam(item)
    })
  }

  confimClearHistoryTest(item: UserExam){
    this.confimDialog = false
    examTestState.deleteUserExam(item).then(()=>{
      if (this.$route.name === ROUTER_NAME.EXAM_SHOW) {
        window.location.reload();
      } else {
        this.$emit('fetchList')
      }
    })
  }

  gotoResult(item: Exam, userExam: UserExam) {
    this.$router.push({
      name: ROUTER_NAME.EXAM_RESULT,
      params: {
        examId: `${item.id}`
      },
      query: {
        user_exam_id: `${userExam.id}`
      }
    })
  }
}
